// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1OLY4","requiredAsterisk":"Info_requiredAsterisk__2RZ_8"};